<template>
    <section class="content-terms">
        <div class="container">
            <div class="content-terms-link">
                <button tag="a" @click="hasHistory()
                    ? $router.go(-1)
                    : $router.push('/')" class="btn-return">
                    <img src="@/assets/img/round-arrow-left.png" alt="round arrow back">
                    <h3>{{ contentTerms.name }}</h3>
                </button>
            </div>
            <div class="content-terms-text" v-html="contentTerms.text">
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            contentTerms: {}
        }
    },
    methods: {
        hasHistory() {
            return window.history.length > 1;
        },
    },
    async mounted() {
        axios.post('/api/v1/legal-information', this.$route.params).then(resp => { 
            this.contentTerms = { ...resp.data }
        }).catch( error => {
            console.log(error);
        })
    },
}
</script>

<style lang="scss">
.content-terms {
    margin-top: 210px;
    @media (max-width: 991px){
        margin-top: 170px;
    }
    &-link {
        button {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            background: 0;
            border: 0;
            margin-left: -25px;
        }
    }
    &-text {
        padding: 50px 0px 100px 0px;
        text-align: left;
        p {
            font-size: 18px;
            font-family: 'Font Regular';
            color: #202620;
        }
    }
}
</style>
